import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const LicenseWarningBanner = ({ daysRemaining, onDismiss }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    if (onDismiss) onDismiss();
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="license-warning-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertTriangle size={16} className="text-amber-600 flex-shrink-0" />
          <p className="text-sm text-amber-800">
            <span className="font-semibold">Abonelik uyarisi:</span>{' '}
            Aboneliginizin bitmesine <span className="font-bold">{daysRemaining} gun</span> kaldi. Lutfen yenileme icin iletisime gecin.
          </p>
        </div>
        <button
          onClick={handleDismiss}
          className="text-amber-600 hover:text-amber-800 p-1 flex-shrink-0"
          data-testid="dismiss-license-warning"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default LicenseWarningBanner;
